import React, { createContext, useContext, useState } from 'react';

type SheetSelectionContextValue = {
  selectedSheetId: number | null;
  setSelectedSheetId: (id: number | null) => void;
  selectedCategoryIds: number[];
  setSelectedCategoryIds: (ids: number[]) => void;
};

const SheetSelectionContext = createContext<SheetSelectionContextValue | null>(null);

export const SheetSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedSheetId, setSelectedSheetId] = useState<number | null>(null);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([]);

  return (
    <SheetSelectionContext.Provider
      value={{ selectedSheetId, setSelectedSheetId, selectedCategoryIds, setSelectedCategoryIds }}
    >
      {children}
    </SheetSelectionContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSheetSelection = () => {
  const ctx = useContext(SheetSelectionContext);
  if (!ctx) throw new Error('useSheetSelection must be used within SheetSelectionProvider');
  return ctx;
};

export default SheetSelectionProvider;
